export const checker =
  <T>(value: T) =>
  (valueToCheck: T): boolean =>
    value === valueToCheck

export default {
  checker,
}
